<template>
  <div class="projectPage">
    <Header
      :menuIndex="2"
      :showBtn="false"
    />
    <div style="display: flex;align-items: center;justify-content: center;">
      <img :src="bannerImg"  mode="aspectFit" style="width: 100%;" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bannerImg: require("@/assets/banner/ai.png"),
    }
  },
  mounted () {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>

</style>
<style scoped>
.projectPage >>> .banner {
  display: none;
}
</style>
